import { AsyncActionButton, FilteredCreditApplication, reportErrorToConsole, useCancelApplication } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { trackEvent } from '../../../services/trackingEvents'
import { ETrackedEvents } from '../../../types/tracking'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface Props {
  creditApp: FilteredCreditApplication
  cancelEventName: ETrackedEvents
}

const DeclinedCancelAppButton = ({ creditApp, cancelEventName }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [submitCancel, isCancelling] = useCancelApplication(EFinancingProgram.Personal)

  const onCancel = () => {
    trackEvent(cancelEventName, creditApp)
    submitCancel(creditApp.id)
      .then(() => {
        navigate(`/creditapplication/${creditApp.id}`)
      })
      .catch(reportErrorToConsole)
  }

  return (
    <AsyncActionButton type="button" className="btn btn-underline" onClick={onCancel} isPending={isCancelling} keepText>
      {t('common.cancelMyApp')}
    </AsyncActionButton>
  )
}

export default DeclinedCancelAppButton
